"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[712],{

/***/ 50712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LoginBoxComponent": function() { return /* binding */ LoginBoxComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93434);
/* harmony import */ var _components_auth_auth_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29873);




var LoginBoxComponent = function(param) {
    var title = param.title, cta = param.cta, classes = param.classes;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var auth = react__WEBPACK_IMPORTED_MODULE_1__.useContext(_components_auth_auth_context__WEBPACK_IMPORTED_MODULE_3__/* .userContext */ .x);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: "login-wrapper-id",
        className: "flexbox colls default-vertical-spacing",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                id: "login-cta",
                className: "default-btn md-size flexbox centered ".concat(classes),
                style: {
                    color: "white",
                    marginTop: "2em"
                },
                onClick: function() {
                    auth.openLoginModal();
                },
                children: t(cta)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "login-title",
                className: "main-whitebox-err",
                children: t(title)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LoginBoxComponent);


/***/ })

}]);